import { Component, Input } from '@angular/core';
import { StatusLabel } from '@shared/ui-components/au-cmms-status-label/status-label/status-label.class';
import { NgClass } from '@angular/common';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-cmms-status-label',
	templateUrl: './au-cmms-status-label.component.html',
	styleUrls: ['./au-cmms-status-label.component.scss'],
	imports: [NgClass, NgxTolgeeModule],
})
export class AuCmmsStatusLabelComponent {
	@Input() set status(statusKey: string) {
		this.labelName = StatusLabel.getNameByKey(statusKey);
		this.labelClass = `${StatusLabel.getColorByKey(statusKey)}-label`;
	}
	labelName: string;
	labelClass: string;
}
